import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Button, ButtonLink } from "../../../misc/button/Button";
import SpinLoading from "../../../misc/loading/SpinLoading";
import { Form } from "antd";
import { DeclarationContext } from "../../../context/DeclarationWrapper";
import { BACKEND_URL } from "../../../../config/config";

export const TitleEditDeclarationModal = (
  props
  ) => {
  const { isAttestation } = useContext(DeclarationContext);
  const [headerTitle, setHeaderTitle] = useState("Déclaration à payer");

  useEffect(() => {
    const isAttestationType = isAttestation(props.record);
    let title;

    if (props.record?.status === 'modification_approved') {
      title = "Modification de déclaration";
    } else if (props.record?.status === 'pending_modification') {
      title = "Déclaration";
    } else if (props.record?.payed === "yes") {
      title = isAttestationType ? "Attestation générée" : "Déclaration payée";
    } else if (props.record?.payed === "ongoing") {
      title = "Déclaration en cours de traitement";
    } else {
      title = isAttestationType ? "Attestation" : "Déclaration à payer";
    }
    setHeaderTitle(title);
  }, [props.record, isAttestation])

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
      }}
    >
      <div>{headerTitle}</div>
      <div style={{ fontWeight: "normal", fontSize: 17, marginRight: 50 }}>
        {props.record?.indice > 0 && `Indice de facture : ${props.record?.indice}`}
      </div>
    </div>
  );
};

export const FooterEditDeclarationModal = ({
  mode,
  isLoading,
  onCloseModal,
  record,
  isAdmin,
}) => {
  const { isAttestation } = useContext(DeclarationContext);

  const [localPayed, setLocalPayed] = useState(record?.payed);
  const [localPaymentMethod, setLocalPaymentMethod] = useState(record?.paymentMethod);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);

  // Sync si le parent met à jour record (ex: après une mutation)
  useEffect(() => {
    setLocalPayed(record?.payed);
    setLocalPaymentMethod(record?.paymentMethod);
  }, [record?.payed, record?.paymentMethod]);

  // Quand payed = 'ongoing' + CB, vérifier automatiquement si la session Worldline est encore active
  useEffect(() => {
    if (localPayed !== 'ongoing' || localPaymentMethod !== 'CB' || !record?.id) return;
    setIsCheckingStatus(true);
    axios
      .get(`${BACKEND_URL}/api/worldline/check-status/${record.id}`, { withCredentials: true })
      .then(res => {
        if (res.data?.apasStatus === 'no') {
          setLocalPayed('no');
          setLocalPaymentMethod(null);
        }
      })
      .catch(() => { /* conserver 'ongoing' en cas d'erreur réseau */ })
      .finally(() => setIsCheckingStatus(false));
  }, [record?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const editFooter = (
    <div className="button-container-modal-edit">
      <div>
        <Button text="Retour" onClick={onCloseModal}>
          Retour
        </Button>
      </div>
      <Form.Item>
        <Button
          text="Modifier"
          type="submit"
          children={isLoading ? <SpinLoading /> : "Modifier"}
        />
      </Form.Item>
    </div>
  );

  const isPayed = localPayed === "yes";
  const isOngoingCB = localPayed === "ongoing" && localPaymentMethod === 'CB';
  const paymentMethod = localPaymentMethod;
  // ongoing + virement : canPay reste true pour permettre le switch vers CB
  // ongoing + CB : canPay=false, nouvelle tentative bloquée
  const canPay = !isPayed && !isOngoingCB && record?.status === 'active' && !isAdmin && !isAttestation(record);
  const showCB = canPay;
  const showVirement = canPay && paymentMethod !== 'virement';
  const showOngoingCB = isOngoingCB && !isAdmin && !isAttestation(record);

  const viewFooter = (
    <div className="button-container-modal-view">
      <Button text="Retour" onClick={onCloseModal}>
        Retour
      </Button>
      {showOngoingCB && (
        <span style={{ color: 'orange' }}>
          {isCheckingStatus ? 'Vérification du statut…' : 'Paiement CB en cours de traitement…'}
        </span>
      )}
      {showCB && (
        <ButtonLink
          to="/declaration-cb-page-v2"
          state={{ message: record }}
          children="Payer par CB"
        />
      )}
      {showVirement && (
        <ButtonLink
          to="/declaration-payment"
          state={{ message: record }}
          children=" Payer par virement"
        />
      )}
    </div>
  );

  return mode === "edit" ? editFooter : viewFooter;
};
